import { InjectionToken } from '@angular/core';

export interface PusherConfig {
  key: string;
  cluster: string;
  /**
   * Where private channels are signed (#406). Leave unset to sign through the API (`users/me/pusher/auth`). The admin
   * portal signs in with the admin realm, which the API doesn't accept, so it sets its Admin app's `v1/pusher/auth`.
   */
  authUrl?: string;
}

export const PUSHER_CONFIG = new InjectionToken<PusherConfig>('PUSHER_CONFIG');
